export default {
    DEFAULT_MAX_CHART_SIZE: 99999,
    DEFAULT_MAX_POLYLINE_SIZE: 99999,
    mergeMetricsAndDescriptors: function(metricsData) {
        let results = [];
        let completeData = null;

        if (metricsData && metricsData.metricDescriptors && metricsData.activityDetailMetrics) {
            completeData = metricsData;
            let measurements = [...metricsData.metricDescriptors];
            let metrics = [...metricsData.activityDetailMetrics];

            if (!metrics || metrics.length === 0) {
                return null;
            }

            for (let k = 0; k < metrics[0].metrics.length; k++) {
                results[k] = [];
            }

            for (let i = 0; i < metrics.length; i++) {
                let dataPoint = metrics[i].metrics;

                for (let j = 0; j < dataPoint.length; j++) {
                    results[j][i] = dataPoint[j];
                }
            }

            measurements.map((value, index) => {
                completeData[value.key] = results[value.metricsIndex];
            });
        }

        return completeData;
    }
};
